import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCu = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { "xmlns:svg": "http://www.w3.org/2000/svg", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 800 400", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0,0h800v400H0z", fill: "#002a8f" }), /* @__PURE__ */ React.createElement("path", { d: "M0,80h800v80H0v80h800v80H0z", fill: "#fff" }), /* @__PURE__ */ React.createElement("path", { d: "M346.4,200L0,0v400z", fill: "#cf142b" }), /* @__PURE__ */ React.createElement("path", { d: "M115.5,140l35.35,108.5 l-92.5-67h114.2l-92.5,67z", fill: "#fff" }));
const ForwardRef = forwardRef(SvgCu);
const Memo = memo(ForwardRef);
export default Memo;
